/* Bravado Labs: shopping motion. Sticky add-to-cart, how-it-works drawing,
   quick view, tactile buttons and the welcome-back chip.
   Fly-to-cart and the free-shipping tip live in cart.js. */
(() => {
  const IMG = (window.BL && window.BL.img) || "";
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const PD = window.bravadoPD || {};
  const THEMES = window.bravadoThemes || {};
  const num = (p) => parseFloat(String(p).replace(/[^0-9.]/g, ""));
  const money = (n) => `$${n.toFixed(2)}`;
  const sub15 = (p) => Math.round(Math.round(num(p) * 100) * 0.85) / 100;
  const STAR = '<svg viewBox="0 0 24 24"><path d="M12 2.5l2.9 6.1 6.6.8-4.9 4.5 1.3 6.6L12 17.3l-5.9 3.2 1.3-6.6-4.9-4.5 6.6-.8z"/></svg>';
  const stars = (r) => `<span class="stars" style="--w:${(r / 5) * 100}%" aria-hidden="true"><span class="off">${STAR.repeat(5)}</span><span class="on">${STAR.repeat(5)}</span></span>`;
  const store = { get: (k, f) => { try { return JSON.parse(localStorage.getItem(k)) ?? f; } catch (_) { return f; } }, set: (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch (_) {} } };

  /* ---------- 1. sticky add-to-cart on product pages ---------- */
  const bar = document.createElement("div");
  bar.className = "satc"; bar.setAttribute("aria-hidden", "true");
  document.body.append(bar);
  const fillBar = () => {
    const pdp = $(".pdp"); if (!pdp || pdp.hidden) return;
    const k = $(".pdp-add", pdp).dataset.add, d = PD[k], sub = $(".plan-sub", pdp).getAttribute("aria-checked") === "true";
    const price = $(sub ? ".pdp-ps" : ".pdp-p1", pdp).textContent, size = ($(".pdp-sizes [aria-checked=true]", pdp) || {}).textContent || "";
    bar.innerHTML = `<img src="${IMG + d.img}" alt=""><span class="satc-info"><b>${d.name}</b><small>${size} · ${sub ? "Subscribe and save 15%" : "One-time"}</small></span><span class="satc-price">${price}</span><button type="button" class="pill pill-dark satc-add" tabindex="-1">Add to cart</button>`;
  };
  bar.addEventListener("click", (e) => { if (e.target.closest(".satc-add")) { const b = $(".pdp .pdp-add"); b && b.click(); } });
  /* the bar shows once the page's own Add to cart has scrolled above the screen (checked on scroll: robust to smooth-scroll libraries) */
  let ctaEl = null;
  const barCheck = () => { if (!ctaEl || !ctaEl.isConnected) return; const on = ctaEl.getBoundingClientRect().bottom < 0; if (on !== bar.classList.contains("on")) showBar(on); };
  addEventListener("scroll", barCheck, { passive: true });
  const showBar = (on) => { bar.classList.toggle("on", on); document.body.classList.toggle("satc-on", on); bar.setAttribute("aria-hidden", String(!on)); $$("button", bar).forEach((b) => (b.tabIndex = on ? 0 : -1)); };


  /* ---------- 6. how it works: the line draws and steps light up with scroll ---------- */
  const pdpRoot = $(".pdp");
  if (pdpRoot) { pdpRoot.addEventListener("click", (ev) => { if (ev.target.closest("[role=radio], .qty button")) requestAnimationFrame(fillBar); }); }
  let howEl = null;
  const how = () => {
    if (!howEl || !howEl.isConnected) return;
    const r = howEl.getBoundingClientRect(), p = Math.max(0, Math.min(1, (innerHeight * .78 - r.top) / (r.height * .9)));
    howEl.style.setProperty("--p", p.toFixed(3));
    howEl.style.setProperty("--how-top", $(".how-steps", howEl).offsetTop + "px");
    $$(".how-steps li", howEl).forEach((li, i, all) => li.classList.toggle("lit", reduce || p >= (i + .35) / all.length));
  };
  addEventListener("scroll", how, { passive: true });

  const onPdp = (k) => {
    const pdp = $(".pdp");
    fillBar();
    ctaEl = $(".pdp-cta", pdp); barCheck();
    howEl = $(".how", pdp); how();
    /* 12: remember the last product viewed */
    store.set("bravado-last", { k, t: Date.now() });
  };
  document.addEventListener("bravado:pdp", (e) => onPdp(e.detail.k));
  /* a product link opened directly renders before this script loads */
  if (document.body.classList.contains("pdp-open") && $(".pdp .pdp-add")) onPdp($(".pdp .pdp-add").dataset.add);
  document.addEventListener("bravado:pdpclose", () => { ctaEl = null; showBar(false); howEl = null; });

  /* ---------- 8. quick view from the product grid ---------- */
  const qv = document.createElement("div");
  qv.className = "qv"; qv.hidden = true;
  document.body.append(qv);
  let qvBack = null;
  const openQV = (k, from) => {
    const d = PD[k]; if (!d) return;
    const t = THEMES[d.theme] || {};
    qvBack = from;
    qv.style.setProperty("--qbg", t.bg || "#eee"); qv.style.setProperty("--qink", t.ink || "#014f58");
    qv.innerHTML = `
      <div class="qv-card" role="dialog" aria-modal="true" aria-labelledby="qv-h">
        <button type="button" class="qv-x" aria-label="Close quick view"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>
        <div class="qv-media"><img class="qv-img" src="${IMG + d.img}" alt="Bravado Labs ${d.name}"></div>
        <div class="qv-body">
          <p class="qv-kick">${d.kicker}</p>
          <h2 id="qv-h">${d.name}</h2>
          <p class="qv-rate">${stars(d.r[0])}<b>${d.r[0].toFixed(1)}</b> · ${d.r[1]} Amazon reviews</p>
          <p class="qv-lead">${d.lead}</p>
          ${d.sizes.length > 1 ? `<div class="qv-sizes" role="radiogroup" aria-label="Size">${d.sizes.map(([s, pr], i) => `<button type="button" role="radio" aria-checked="${i === 0}" data-price="${pr}">${s}</button>`).join("")}</div>` : `<p class="qv-size">${d.sizes[0][0]}</p>`}
          <div class="qv-plans" role="radiogroup" aria-label="Purchase option">
            <button type="button" role="radio" aria-checked="true" data-plan="sub"><span>Subscribe and save 15%<small>Auto-ships, skip or cancel anytime</small></span><em><s>${d.sizes[0][1]}</s> <b class="qv-ps">${money(sub15(d.sizes[0][1]))}</b></em></button>
            <button type="button" role="radio" aria-checked="false" data-plan="one"><span>One-time purchase</span><em class="qv-p1">${d.sizes[0][1]}</em></button>
          </div>
          <div class="qv-cta"><div class="qty"><button type="button" aria-label="Decrease quantity">−</button><output>1</output><button type="button" aria-label="Increase quantity">+</button></div>
            <button type="button" class="pill pill-dark qv-add" data-add="${k}">Add to cart</button></div>
          <a class="qv-more" href="#product-${k}">View full details</a>
        </div>
      </div>`;
    qv.hidden = false; document.body.classList.add("qv-on");
    requestAnimationFrame(() => { qv.classList.add("in"); $(".qv-x", qv).focus(); });
  };
  const closeQV = (refocus = true) => {
    qv.classList.remove("in"); document.body.classList.remove("qv-on");
    setTimeout(() => (qv.hidden = true), reduce ? 0 : 320);
    if (refocus && qvBack) qvBack.focus();
  };
  document.addEventListener("click", (e) => { const b = e.target.closest("[data-qv]"); if (b) { e.preventDefault(); e.stopPropagation(); openQV(b.dataset.qv, b); } }, true);
  qv.addEventListener("click", (e) => {
    if (e.target === qv || e.target.closest(".qv-x")) return closeQV();
    if (e.target.closest(".qv-more")) return closeQV(false);
    const r = e.target.closest("[role=radio]");
    if (r) {
      $$("[role=radio]", r.parentElement).forEach((x) => x.setAttribute("aria-checked", String(x === r)));
      if (r.dataset.price) { $(".qv-p1", qv).textContent = r.dataset.price; $(".qv-plans s", qv).textContent = r.dataset.price; $(".qv-ps", qv).textContent = money(sub15(r.dataset.price)); }
      return;
    }
    const q = e.target.closest(".qty button");
    if (q) { const o = $(".qty output", qv); o.textContent = Math.max(1, Math.min(9, +o.textContent + (q.textContent === "+" ? 1 : -1))); return; }
    const a = e.target.closest(".qv-add");
    if (a) {
      const size = $(".qv-sizes [aria-checked=true]", qv), plan = $(".qv-plans [aria-checked=true]", qv).dataset.plan;
      window.bravadoCart.add({ k: a.dataset.add, size: size ? size.textContent : undefined, plan, qty: +$(".qty output", qv).textContent }, a);
      setTimeout(() => closeQV(false), reduce ? 0 : 700);
    }
  });
  qv.addEventListener("keydown", (e) => {
    if (e.key === "Escape") return closeQV();
    if (e.key === "Tab") { const f = $$("button, a", qv); if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); } else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); } }
  });

  /* ---------- 11. tactile buttons: a little bump on quantity changes, a tick on phones ---------- */
  document.addEventListener("click", (e) => {
    const q = e.target.closest(".qty button, .cd-qty button");
    if (q) { const o = q.parentElement.querySelector("output"); if (o && !reduce) o.animate([{ transform: "scale(1)" }, { transform: "scale(1.35)" }, { transform: "scale(1)" }], { duration: 260, easing: "cubic-bezier(.34,1.56,.64,1)" }); if (navigator.vibrate) navigator.vibrate(6); }
  });

  /* ---------- 12. welcome back ---------- */
  const visits = store.get("bravado-visits", 0);
  let firstThisSession = false;
  try { if (!sessionStorage.getItem("bravado-session")) { sessionStorage.setItem("bravado-session", "1"); store.set("bravado-visits", visits + 1); firstThisSession = true; } } catch (_) {}
  const last = store.get("bravado-last", null);
  if (firstThisSession && visits >= 1 && last && PD[last.k] && !location.hash.startsWith("#product-")) {
    const d = PD[last.k];
    const chip = document.createElement("div");
    chip.className = "wb"; chip.setAttribute("role", "status");
    chip.innerHTML = `<a href="#product-${last.k}"><img src="${IMG + d.img}" alt=""><span><small>Welcome back. Pick up where you left off:</small><b>${d.name}</b></span></a><button type="button" aria-label="Dismiss"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>`;
    document.body.append(chip);
    const hide = () => { chip.classList.remove("in"); setTimeout(() => chip.remove(), 400); };
    chip.addEventListener("click", (e) => { if (e.target.closest("button") || e.target.closest("a")) hide(); });
    setTimeout(() => chip.classList.add("in"), 1400);
    addEventListener("hashchange", hide, { once: true });
  }
})();
